import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionWrapper, FadeIn, CTAButton } from './Shared';
export const Bonuses = () => {
  const bonuses = [{
    title: 'Bono 1 — Guía Anti Estrés Digestivo',
    desc: 'Técnicas y hábitos para calmar tu sistema digestivo y reducir la inflamación causada por el estrés.'
  }, {
    title: 'Bono 2 — Guía Express: Cómo Deshincharte en 24-48hs',
    desc: 'Un plan de acción rápido para cuando necesitás resultados inmediatos y sentirte liviana ya.'
  }, {
    title: 'Bono 3 — Lista Roja y Verde de Alimentos',
    desc: 'Sabé exactamente qué alimentos te inflaman y cuáles te ayudan a deshincharte.'
  }, {
    title: 'Bono 4 — Plan Deshinchate 7 Días',
    desc: 'Un plan paso a paso de una semana completa para empezar a ver cambios reales.'
  }];
  return <SectionWrapper className="bg-sage-900 text-white relative overflow-hidden" data-id="element-14">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-sage-800 rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/2" data-id="element-15" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-sage-800 rounded-full blur-3xl opacity-50 translate-y-1/2 -translate-x-1/2" data-id="element-16" />

      <div className="relative z-10" data-id="element-17">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-16" data-id="element-18">
          <FadeIn data-id="element-19">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-rose/20 rounded-full mb-6" data-id="element-20">
              <GiftIcon className="w-8 h-8 text-rose-light" data-id="element-21" />
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-22">
              BONOS EXCLUSIVOS
            </h2>
            <div className="inline-block bg-rose px-4 py-1 rounded-full text-sm font-bold tracking-wider uppercase mb-4" data-id="element-23">
              (HOY GRATIS)
            </div>
          </FadeIn>
        </div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-8 md:mb-16 max-w-3xl mx-auto" data-id="element-24">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-25">
              <div className="bg-sage-800/50 border border-sage-700 p-6 rounded-2xl backdrop-blur-sm h-full" data-id="element-26">
                <div className="text-2xl mb-3" data-id="element-27">🎁</div>
                <h3 className="text-lg font-bold text-sage-100 mb-2" data-id="element-28">
                  {bonus.title}
                </h3>
                <p className="text-sage-200/80 text-sm leading-relaxed" data-id="element-29">
                  {bonus.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-30">
          <div className="max-w-2xl mx-auto text-center bg-white/5 border border-white/10 rounded-2xl md:rounded-3xl p-6 md:p-8 backdrop-blur-md" data-id="element-31">
            <div className="flex flex-col md:flex-row items-center justify-center gap-4 mb-8" data-id="element-32">
              <span className="text-xl text-sage-200/80" data-id="element-33">
                Valor total de bonos:
              </span>
              <span className="text-2xl font-bold text-sage-300 line-through decoration-rose decoration-2" data-id="element-34">
                $45.000 ARS
              </span>
              <span className="text-2xl font-bold text-white flex items-center gap-2" data-id="element-35">
                🔥 Hoy →{' '}
                <span className="text-rose-light bg-rose px-3 py-1 rounded-lg" data-id="element-36">
                  GRATIS
                </span>
              </span>
            </div>
            <CTAButton data-id="element-37">👉 Acceder a Deshinchate ahora</CTAButton>
          </div>
        </FadeIn>
      </div>
    </SectionWrapper>;
};